export default {"src":"/_next/static/media/img-landing-hero-mobile-2.9b28c0de.svg","height":106,"width":328,"blurWidth":0,"blurHeight":0};